import { Component, ElementRef, viewChild } from '@angular/core';
import { ButtonComponent } from "../button/button.component";
import { ModalIconComponent, ModalIconType } from "../modal-icon/modal-icon.component";
import { NgClass } from "@angular/common";

@Component({
  selector: 'modal',
  imports: [
    ButtonComponent,
    ModalIconComponent,
    NgClass
  ],
  templateUrl: './modal.component.html',
  styleUrl: './modal.component.scss'
})
export class ModalComponent {
  protected dom_modal = viewChild.required<ElementRef>('modal');
  protected title: string = '';
  protected message: string = '';
  protected positive_text: string = '';
  protected negative_text: string = '';
  protected positive_fn!: Function;
  protected negative_fn!: Function;
  protected type: 'info' | 'confirm' | 'confirm-warning' = 'info';
  protected negativeType: 'secondary' | 'primary' | 'warning' = 'secondary';
  protected positiveType: 'secondary' | 'primary' | 'warning' = 'primary';
  protected warningType: 'secondary' | 'primary' | 'warning' = 'warning';
  protected closable: boolean = true;
  protected showBackDrop: boolean = true;

  //modal icon config
  protected iconPreset: ModalIconType | undefined;
  protected bi_icon!: string;
  protected iconType!: ModalIconType;

  private ngOnInit() {
    this.dom_modal().nativeElement.addEventListener('keydown', (event: KeyboardEvent) => {
      if (event.key === 'Escape' && !this.closable) {
        event.stopPropagation();
        event.preventDefault();
      }
    });
  }

  public showInfo(title: string,
                  message: string,
                  positiveText: string,
                  positiveFn: Function = () => {}) {
    this.resetConfig();
    this.title = title;
    this.message = message;
    this.positive_text = positiveText;
    this.positive_fn = positiveFn;
    this.type = 'info';
    this.onShow();
    return this;
  }

  public showConfirm(title: string,
                     message: string,
                     positiveText: string,
                     negativeText: string,
                     positiveFn: Function = () => {},
                     negativeFn: Function = () => {}) {
    this.resetConfig();
    this.title = title;
    this.message = message;
    this.positive_text = positiveText;
    this.negative_text = negativeText;
    this.positive_fn = positiveFn;
    this.negative_fn = negativeFn;
    this.type = 'confirm';
    this.onShow();
    return this;
  }

  public showConfirmWarning(title: string,
                            message: string,
                            positiveText: string,
                            negativeText: string,
                            positiveFn: Function = () => {},
                            negativeFn: Function = () => {}) {
    this.resetConfig();
    this.title = title;
    this.message = message;
    this.positive_text = positiveText;
    this.negative_text = negativeText;
    this.positive_fn = positiveFn;
    this.negative_fn = negativeFn;
    this.type = 'confirm-warning';
    this.onShow();
    return this;
  }

  public setButtonTypes(button: 'negative' | 'positive' | 'warning', type: 'secondary' | 'primary' | 'warning') {
    switch (button) {
      case 'negative': this.negativeType = type;
        break;
      case 'positive': this.positiveType = type;
        break;
      case 'warning': this.warningType = type;
    }

    return this;
  }

  public setIcon(preset: ModalIconType | null, customIcon?: string, type?: ModalIconType) {
    if (preset !== null) {
      this.iconPreset = preset;
      this.bi_icon = '';
      this.iconType = preset;
    } else {
      this.iconPreset = undefined;
      this.bi_icon = customIcon ?? '';
      this.iconType = type ?? 'default';
    }
    return this;
  }

  public disableClose() {
    this.closable = false;
    return this;
  }

  public hideBackdrop() {
    this.showBackDrop = false;
    return this;
  }

  private resetConfig() {
    this.iconPreset = undefined;
    this.bi_icon = '';
    this.iconType = 'default';
    this.closable = true;
    this.showBackDrop = true;
    this.negativeType = 'secondary';
    this.positiveType = 'primary';
    this.warningType = 'warning';  }

  positiveAction() {
    if (this.positive_fn) {
      this.positive_fn();
    }
    this.onDismiss();
  }

  negativeAction() {
    if (this.negative_fn) {
      this.negative_fn();
    }
    this.onDismiss();
  }

  onDismiss() {
    if (!this.closable) return;
    this.dom_modal().nativeElement.close();
  }

  onShow() {
    this.dom_modal().nativeElement.showModal();
  }
}
